import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useCartStore = create(
  persist(
    (set) => ({
      cartStore: null,
      setCartStore: (cartStore) => set({ cartStore: cartStore }),
    }),
    {
      name: "cart-storage",
      storage: createJSONStorage(() => {
        if (typeof window !== "undefined") {
          return localStorage;
        }
        return {
           getItem: () => null,
           setItem: () => {},
           removeItem: () => {},
        };
      }),
    }
  )
);
